// MUS-607: in a window 370px high or less (568x320 and 592x360, small phones
// in landscape) the verification code form is taller than the room left in
// the sign-in card, so its heading started under the card's logo (2144 px²
// of overlap at both). From 375px high (667x375) the heading clears the logo.
// There the card leaves the logo out on that step.
export const NO_LOGO_QUERY = '(max-height: 370px)';
